import type React from 'react';
import type { PerfilVisaoGeral } from '../../../src/lib/visaoGeral/perfis';
import type { PropsTelaVisaoGeral } from '../tipos';
import TelaPadrao from './TelaPadrao';
import TelaDiretoria from './TelaDiretoria';
import TelaComercial from './TelaComercial';
import TelaVendas from './TelaVendas';
import TelaParceiros from './TelaParceiros';
import TelaGestaoFinanceiro from './TelaGestaoFinanceiro';
import TelaFaturamento from './TelaFaturamento';
import TelaBackoffice from './TelaBackoffice';
import TelaCobranca from './TelaCobranca';
import TelaPosVenda from './TelaPosVenda';
import TelaTecnologia from './TelaTecnologia';
import TelaMarketing from './TelaMarketing';
import TelaTecnologiaMarketing from './TelaTecnologiaMarketing';
import TelaCampo from './TelaCampo';

/**
 * Telas de perfil já construídas. Perfil que não está aqui continua vendo a Visão
 * Geral antiga (views/DashboardHome.tsx) até a tarefa dele no projeto 24
 * (#6495–#6505) — assim ninguém perde a tela de hoje no meio da troca.
 */
export const TELAS: Partial<Record<PerfilVisaoGeral, React.FC<PropsTelaVisaoGeral>>> = {
  padrao: TelaPadrao,
  diretoria: TelaDiretoria,
  comercial: TelaComercial,
  vendas: TelaVendas,
  parceiros: TelaParceiros,
  'gestao-financeiro': TelaGestaoFinanceiro,
  faturamento: TelaFaturamento,
  backoffice: TelaBackoffice,
  cobranca: TelaCobranca,
  'pos-venda': TelaPosVenda,
  tecnologia: TelaTecnologia,
  marketing: TelaMarketing,
  'tecnologia-marketing': TelaTecnologiaMarketing,
  campo: TelaCampo,
};
